import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserMe } from 'src/app/auth/_models/user-me';

const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json;charset=UTF-8',
		'Accept-Language': '1',
	}),
	observe: 'response' as 'body'// to display the full response & as 'body' for type cast
};

@Injectable({ providedIn: 'root' })
export class UsersMeService {
  currentUsersMe: any;

	constructor(private http: HttpClient) {	}

	getCurrentUsersMe(): Observable<any> {
    return this.http.get(`${environment.loginApi}/users/me`);
  }	
}
